<script lang="ts" context="module">
    export enum LoginPanelStyle {
        WHITE = "white",
        GRAY = "gray",
    }
</script>

<script lang="ts">
    import { TokenStore } from "../stores/TokenStore";
    import LoginCatImg from "../images/sign-up-cat.png";
    import { ServiceConsts } from "../services/ServiceConsts";
    import { onDestroy } from "svelte";
    import { extensionInit } from "../stores/StoreInitializer";

    export let afterLogin = async () => {};
    export let style: LoginPanelStyle = LoginPanelStyle.WHITE;

    let tokenUnsubscribe = undefined;

    const login = (hash) => {
        window.open(ServiceConsts.LOGIN_URL + hash, "_blank");

        tokenUnsubscribe = TokenStore.subscribe(async (token) => {
            if (!token.expired) {
                await extensionInit();
                await afterLogin();
            }
        });
    };

    onDestroy(() => {
        if (tokenUnsubscribe) {
            tokenUnsubscribe();
        }
    });
</script>

<div
    class="login-screen"
    class:login-screen--white={style === LoginPanelStyle.WHITE}
>
    <img
        class="login-screen__image"
        src={LoginCatImg}
        alt="Login to Collabwriting"
    />
    <h2 class="login-screen__title">Let's set you up 😊</h2>

    <button
        class="login-screen__btn"
        on:click|stopPropagation|preventDefault={login.bind(this, "#google")}
    >
        <svg
            class="login-screen__btn-icon"
            width="43"
            height="44"
            viewBox="0 0 43 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M42.5807 17.9925H40.8704V17.9044H21.7624V26.3968H33.7612C32.0108 31.3405 27.307 34.8893 21.7624 34.8893C14.7274 34.8893 9.02371 29.1856 9.02371 22.1506C9.02371 15.1156 14.7274 9.4119 21.7624 9.4119C25.0098 9.4119 27.9641 10.6369 30.2134 12.638L36.2188 6.63274C32.4269 3.0988 27.3547 0.919434 21.7624 0.919434C10.0375 0.919434 0.53125 10.4257 0.53125 22.1506C0.53125 33.8755 10.0375 43.3817 21.7624 43.3817C33.4873 43.3817 42.9936 33.8755 42.9936 22.1506C42.9936 20.7271 42.8472 19.3375 42.5807 17.9925Z"
                fill="#FFC107"
            />
            <path
                d="M2.98047 12.2685L9.95596 17.3843C11.8434 12.7112 16.4145 9.4119 21.7637 9.4119C25.0109 9.4119 27.9653 10.6369 30.2148 12.638L36.22 6.63274C32.4281 3.0988 27.356 0.919434 21.7637 0.919434C13.6088 0.919434 6.53669 5.5234 2.98047 12.2685Z"
                fill="#FF3D00"
            />
            <path
                d="M21.7604 43.3826C27.2445 43.3826 32.2273 41.2839 35.9948 37.871L29.4238 32.3106C27.2205 33.9862 24.5284 34.8923 21.7604 34.8901C16.2382 34.8901 11.5493 31.369 9.78286 26.4551L2.85938 31.7894C6.37313 38.665 13.5089 43.3826 21.7604 43.3826Z"
                fill="#4CAF50"
            />
            <path
                d="M42.58 17.9924H40.8698V17.9043H21.7617V26.3968H33.7605C32.9232 28.7497 31.4148 30.8055 29.4219 32.3107L29.4251 32.3085L35.9961 37.8691C35.5312 38.2915 42.9929 32.7661 42.9929 22.1505C42.9929 20.727 42.8465 19.3375 42.58 17.9924Z"
                fill="#1976D2"
            />
        </svg>
        <span> Sign in with Google </span>
    </button>

    <button
        class="login-screen__btn"
        on:click|stopPropagation|preventDefault={login.bind(this, "#microsoft")}
    >
        <svg
            class="login-screen__btn-icon"
            width="43"
            height="44"
            viewBox="0 0 43 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_3009_11142)">
                <path
                    d="M20.5595 21.12H0.378906V0.939453H20.5595V21.12Z"
                    fill="#F1511B"
                />
                <path
                    d="M42.8405 21.12H22.6602V0.939453H42.8405V21.12Z"
                    fill="#80CC28"
                />
                <path
                    d="M20.559 43.4017H0.378906V23.2212H20.559V43.4017Z"
                    fill="#00ADEF"
                />
                <path
                    d="M42.8405 43.4017H22.6602V23.2212H42.8405V43.4017Z"
                    fill="#FBBC09"
                />
            </g>
            <defs>
                <clipPath id="clip0_3009_11142">
                    <rect
                        width="42.4623"
                        height="42.4623"
                        fill="white"
                        transform="translate(0.378906 0.939453)"
                    />
                </clipPath>
            </defs>
        </svg>
        <span> Sign in with Microsoft </span>
    </button>

    <button
        class="login-screen__btn"
        on:click|stopPropagation|preventDefault={login.bind(this, "#github")}
    >
        <svg
            class="login-screen__btn-icon"
            width="43"
            height="43"
            viewBox="0 0 43 43"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M21.3093 0.959473C18.5212 0.959473 15.7604 1.50863 13.1845 2.5756C10.6086 3.64256 8.26808 5.20644 6.29659 7.17793C2.31497 11.1595 0.078125 16.5598 0.078125 22.1906C0.078125 31.5748 6.17147 39.5365 14.6002 42.3602C15.6618 42.5301 16.0015 41.8719 16.0015 41.2987V37.7106C10.1205 38.9845 8.86782 34.8656 8.86782 34.8656C7.89119 32.4028 6.51117 31.7446 6.51117 31.7446C4.57913 30.4283 6.65978 30.4708 6.65978 30.4708C8.7829 30.6194 9.90815 32.6576 9.90815 32.6576C11.7553 35.8847 14.8762 34.9293 16.0864 34.4198C16.2775 33.0397 16.8295 32.1056 17.424 31.5748C12.7107 31.044 7.7638 29.2181 7.7638 21.1291C7.7638 18.7724 8.57059 16.8828 9.95061 15.3754C9.7383 14.8446 8.99521 12.6366 10.1629 9.7704C10.1629 9.7704 11.9463 9.19716 16.0015 11.936C17.6788 11.4689 19.5046 11.2354 21.3093 11.2354C23.1139 11.2354 24.9398 11.4689 26.6171 11.936C30.6722 9.19716 32.4556 9.7704 32.4556 9.7704C33.6234 12.6366 32.8803 14.8446 32.668 15.3754C34.048 16.8828 34.8548 18.7724 34.8548 21.1291C34.8548 29.2394 29.8867 31.0228 25.1521 31.5536C25.9164 32.2117 26.6171 33.5068 26.6171 35.4813V41.2987C26.6171 41.8719 26.9568 42.5513 28.0396 42.3602C36.4683 39.5152 42.5404 31.5748 42.5404 22.1906C42.5404 19.4025 41.9913 16.6417 40.9243 14.0658C39.8574 11.4899 38.2935 9.14943 36.322 7.17793C34.3505 5.20644 32.01 3.64256 29.4341 2.5756C26.8582 1.50863 24.0974 0.959473 21.3093 0.959473V0.959473Z"
                fill="black"
            />
        </svg>
        <span> Sign in with GitHub </span>
    </button>

    <button
        class="login-screen__btn"
        on:click|stopPropagation|preventDefault={login.bind(this, "#email")}
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            class="login-screen__btn-icon"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
            />
        </svg>
        <span> Sign in with Email </span>
    </button>

    <span class="login-screen__text-btn">
        Create <a
            href={ServiceConsts.SIGNUP_URL}
            class="login-screen__text-btn-href">new email account</a
        >
    </span>
</div>

<style>
    @import "../main.css";

    .login-screen {
        @apply reset flex h-full w-full flex-col items-center justify-center gap-2 bg-gray-100 p-4 !important;
    }

    .login-screen--white {
        @apply bg-white !important;
    }

    .login-screen__image {
        @apply reset w-32 !important;
    }

    .login-screen__title {
        @apply reset mb-8 text-xl !important;
    }

    .login-screen__btn {
        @apply reset relative my-1 w-full cursor-pointer select-none rounded-full border border-solid border-gray-200 bg-white py-2 text-center uppercase text-black no-underline hover:border-yellow-300 hover:bg-yellow-200 !important;
    }

    .login-screen__btn span {
        @apply text-black !important;
    }

    .login-screen__btn-icon {
        @apply reset absolute left-4 h-6 w-6 !important;
    }

    .login-screen__text-btn {
        @apply reset w-full text-right text-xs !important;
    }

    .login-screen__text-btn-href {
        @apply reset text-xs font-bold no-underline hover:underline !important;
    }

    a.login-screen__btn:hover svg path {
        @apply fill-[revert-layer] !important;
    }

    a.login-screen__btn svg path {
        @apply fill-[revert-layer] !important;
    }
</style>
